export default function ImportantNoteIconSmall() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <rect width="18" height="18" fill="white" fillOpacity="0.0901961" />
      <path
        d="M4.78292 5.38281H2.37221C2.03936 5.38281 1.76953 5.65264 1.76953 5.98549V14.423C1.76953 15.4215 2.57901 16.231 3.57757 16.231C4.57612 16.231 5.3856 15.4215 5.3856 14.423V5.98549C5.3856 5.65264 5.11577 5.38281 4.78292 5.38281Z"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.38616 13.8192V2.3683C5.38616 2.03546 5.65599 1.76562 5.98884 1.76562H15.6317C15.9645 1.76562 16.2344 2.03546 16.2344 2.3683V14.4219C16.2344 15.4204 15.4249 16.2299 14.4263 16.2299H3.57812"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.79688 4.78125H13.8237"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.79688 7.78906H13.8237"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.79688 10.8047H13.8237"
        stroke="#232323"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
